import { AvfDataView } from "../models";

export const loadData = async (): Promise<AvfDataView[]> => {
  let result: AvfDataView[] = [];
  const response: any = await fetch(
    "https://avf-dashboard-api.azurewebsites.net/api/getData?queryid=6075b2f5-c5ef-e511-80cc-0050568dbd2f"
  );
  const body = await response.json();
  if (response.status === 200 && Array.isArray(body.data)) {
    result = body.data;
  }
  return result;
};
